import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { webAuth } from '../api/client';

export default function VerifyEmailScreen() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // 'verifying' | 'success' | 'error'
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) { setStatus('error'); setMessage('Invalid verification link.'); return; }

    webAuth.verifyEmail(token)
      .then(() => setStatus('success'))
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.error || 'Verification failed. The link may have expired.');
      });
  }, [searchParams]);

  return (
    <div style={s.container}>
      <div style={s.card}>
        {status === 'verifying' && (
          <>
            <div style={s.spinner} />
            <p style={s.text}>Verifying your email...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div style={s.icon}>✅</div>
            <h2 style={s.title}>Email Verified!</h2>
            <p style={s.text}>Your account is now active. You can sign in.</p>
            <button style={s.button} onClick={() => navigate('/login')}>Sign In</button>
          </>
        )}
        {status === 'error' && (
          <>
            <div style={s.icon}>❌</div>
            <h2 style={s.title}>Verification Failed</h2>
            <p style={s.text}>{message}</p>
            <Link to="/login" style={s.link}>Back to Sign In</Link>
          </>
        )}
      </div>
    </div>
  );
}

const s = {
  container: { minHeight: '100vh', backgroundColor: '#f0f2f5', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 },
  card:      { backgroundColor: '#fff', padding: '40px', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px', textAlign: 'center' },
  spinner:   { width: 40, height: 40, border: '4px solid #e0e0e0', borderTop: '4px solid #007AFF', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 20px' },
  icon:      { fontSize: 48, marginBottom: 16 },
  title:     { fontSize: 24, fontWeight: 700, color: '#1a1a2e', marginBottom: 12 },
  text:      { color: '#555', fontSize: 15, lineHeight: 1.6, marginBottom: 24 },
  button:    { width: '100%', padding: '14px', backgroundColor: '#1a1a2e', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: 'pointer' },
  link:      { color: '#007AFF', textDecoration: 'none', fontSize: 15 },
};